// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 698 ? "mediapipe-vision" : chunkId) + "." + {"422":"1d143720","471":"9ce2b7f4","698":"289156be","833":"67f285ca"}[chunkId] + ".chunk.js";
};